export default {
    data: () => ({
        translations: {
            createTitle: {
                el: "Νέο Προϊόν ή Υπηρεσία",
                en: "New Product or Service",
                it: "Nuovo prodotto o servizio"
            },
            updateTitle: {
                el: "Επεξεργασία Προϊόντος ή Υπηρεσίας",
                en: "Edit Product or Service",
                it: "Modifica prodotto o servizio"
            },
            productName: {
                el: "Όνομα Προϊόντος",
                en: "Product Name",
                it: "Nome del prodotto"
            },
            productDescription: {
                el: "Περιγραφή Προϊόντος",
                en: "Product Description",
                it: "Descrizione del prodotto"
            },
            prices: {
                el: "Τιμές",
                en: "Prices",
                it: "Prezzi"
            },
            sellingPrice: {
                el: "Τιμή Πώλησης",
                en: "Selling Price",
                it: "Prezzo di vendita"
            },
            wholesalePrice: {
                el: "Τιμή Χονδρικής",
                en: "Wholesale Price",
                it: "Prezzo all'ingrosso"
            },
            selectCategory: {
                el: "Επίλεξε Κατηγορία",
                en: "Select Category",
                it: "Scegliere la categoria"
            },
            imageCheckbox: {
                el: "Θέλω να εμφανίζεται το προϊόν με φωτογραφία στην εφαρμογή",
                en:
                    "I want the product to be displayed with an image in the application",
                it: "Voglio che il prodotto sia visualizzato con un'immagine nell'applicazione"
            },
            imageTitle: {
                el: "Εικόνα Προϊόντος (προαιρετικό)",
                en: "Product Image (optional)",
                it: "Immagine del prodotto (opzionale)"
            },
            daysCheckbox: {
                el: "Θέλω να εμφανίζεται το προϊόν συγκεκριμένες μέρες",
                en: "I want the product to be displayed on specific days",
                it: "Voglio che il prodotto sia visualizzato in giorni specific"
            },
            daysInfo: {
                el: "Επίλεξε τις ημέρες που θέλετε να εμφανίζεται το προϊόν στο κοινό",
                en: "Choose the days you want the product to be displayed in public",
                it: "Scegli i giorni in cui vuoi che il prodotto sia esposto in pubblico"
            },
            published: {
                el: "Προϊόν ορατό στο κοινό",
                en: "Published",
                it: "Prodotto visibile al pubblico"
            },
            maxPricePerTransaction: {
                el: "Μέγιστη τιμή ανά συναλλαγή",
                en: "Maximum price per transaction",
                it: "Prezzo massimo per transazione" 
            },
        }
    })
};
